<template>
   <div>
      <v-row no-gutters class="pa-0">
         <v-col>
            <v-card outlined flat class="pb-2">
               <table>
                  <tr>
                     <td colspan="7" class="pl-1 py-1">Year Restriction</td>
                  </tr>
                  <tr>
                     <td colspan="2" class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(-1)"
                           value="-1"
                           hide-details
                           :readonly="yearreadonly"
                        >
                        </v-checkbox>
                     </td>
                     <td colspan="5" class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(0)"
                           value="0"
                           hide-details
                           :readonly="yearreadonly"
                        >
                        </v-checkbox>
                     </td>
                  </tr>
                  <tr>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(1)"
                           value="1"
                           hide-details
                           :readonly="yearreadonly"
                        >
                        </v-checkbox>
                     </td>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(2)"
                           value="2"
                           hide-details
                           :readonly="yearreadonly"
                        >
                        </v-checkbox>
                     </td>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(3)"
                           value="3"
                           hide-details
                           :readonly="yearreadonly"
                        >
                        </v-checkbox>
                     </td>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(4)"
                           value="4"
                           hide-details
                           :readonly="yearreadonly"
                        >
                        </v-checkbox>
                     </td>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(5)"
                           value="5"
                           hide-details
                           :readonly="yearreadonly"
                        ></v-checkbox>
                     </td>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(6)"
                           value="6"
                           hide-details
                           :readonly="yearreadonly"
                        ></v-checkbox>
                     </td>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(7)"
                           value="7"
                           hide-details
                           :readonly="yearreadonly"
                        ></v-checkbox>
                     </td>
                  </tr>
                  <tr>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(8)"
                           value="8"
                           hide-details
                           :readonly="yearreadonly"
                        ></v-checkbox>
                     </td>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(9)"
                           value="9"
                           hide-details
                           :readonly="yearreadonly"
                        ></v-checkbox>
                     </td>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(10)"
                           value="10"
                           hide-details
                           :readonly="yearreadonly"
                        ></v-checkbox>
                     </td>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(11)"
                           value="11"
                           hide-details
                           :readonly="yearreadonly"
                        ></v-checkbox>
                     </td>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(12)"
                           value="12"
                           hide-details
                           :readonly="yearreadonly"
                        ></v-checkbox>
                     </td>
                     <td class="pr-2">
                        <v-checkbox
                           v-model="yearselected"
                           class="pa-0 my-0"
                           :label="GetLabel(13)"
                           value="13"
                           hide-details
                           :readonly="yearreadonly"
                        ></v-checkbox>
                     </td>
                  </tr>
               </table>
            </v-card>
         </v-col>
      </v-row>
   </div>
</template>
<script>
   export default {
      props: {
         years: Array,
         yearreadonly: {
            type: Boolean,
            default: function() {
               return false;
            },
         },
      },
      computed: {
         yearselected: {
            get: function() {
               return this.years;
            },
            set: function(newValue) {
               this.$emit("update:years", newValue);
            },
         },
      },
      methods: {
         GetLabel(yr) {
            let label;
            if (yr == -1) {
               label = this.$vuetify.breakpoint.mobile ? "PS 1" : "Preschool 1";
            } else if (yr == 0) {
               label = this.$vuetify.breakpoint.mobile ? "PS 2" : "Preschool 2";
            } else {
               label = this.$vuetify.breakpoint.mobile ? yr.toString() : "Year " + yr.toString();
            }
            return label;
         },
      },
   };
</script>
